/**
 * Initialize the newsletter select all
 */
export function NewsletterSelectAllInit() {
    const form: HTMLFormElement = document.querySelector('#newsletterFormNwd');

    if (form) {
        const checkboxes: NodeListOf<HTMLInputElement> = form.querySelectorAll('input[type="checkbox"][id*="newsletterFormNwd-newsletter_topic"]');

        if (checkboxes.length > 0) {
            const selectAllNewsletters: HTMLInputElement = form.querySelector('.select-all-newsletters');

            /**
             * Select all checkboxes
             */
            const selectAllCheckboxes = () => {
                checkboxes.forEach((checkbox) => {
                    if (checkbox === selectAllNewsletters) {
                        return;
                    }

                    checkbox.checked = selectAllNewsletters.checked;
                });
            }

            /**
             * Check if all checkboxes are selected
             * If all checkboxes are selected, check the all-newsletter checkbox
             * If not all checkboxes are selected, mark the all-newsletter checkbox as indeterminate
             * If no checkbox is selected, uncheck the all-newsletter checkbox
             */
            const updateSelectAllIfAllCheckboxesChecked = () => {
                let selectedOptions = 0;
                let deselectedOptions = 0;

                checkboxes.forEach((checkbox) => {
                    if (checkbox === selectAllNewsletters) {
                        return;
                    }

                    if (checkbox.checked) {
                        selectedOptions++;
                    } else {
                        deselectedOptions++;
                    }
                });

                selectAllNewsletters.checked = deselectedOptions === 0;
                selectAllNewsletters.indeterminate = deselectedOptions !== 0 && selectedOptions !== 0;
            }

            selectAllNewsletters.addEventListener('change', selectAllCheckboxes, {passive: true});

            checkboxes.forEach((checkbox) => {
                checkbox.addEventListener('change', updateSelectAllIfAllCheckboxesChecked, {passive: true});
            });
        }
    }
}
